import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Lock, LogOut, LayoutDashboard } from "lucide-react";

export default function Navbar({ variant = "default" }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-white/70 backdrop-blur-xl border-b border-slate-200/50">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <div className="w-8 h-8 rounded-lg bg-slate-900 text-white flex items-center justify-center">
            <Lock className="w-4 h-4" />
          </div>
          <span className="font-display font-bold text-lg tracking-tight">ResumeLock</span>
        </Link>

        <nav className="flex items-center gap-2">
          {user && user !== false ? (
            <>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => nav("/dashboard")}
                data-testid="nav-dashboard-btn"
                className="font-medium"
              >
                <LayoutDashboard className="w-4 h-4 mr-2" /> Dashboard
              </Button>
              <span className="text-sm text-slate-500 hidden sm:inline-block" data-testid="nav-user-email">
                {user.email}
              </span>
              <Button
                variant="outline"
                size="sm"
                onClick={async () => { await logout(); nav("/"); }}
                data-testid="nav-logout-btn"
              >
                <LogOut className="w-4 h-4 mr-2" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => nav("/login")} data-testid="nav-login-btn">
                Log in
              </Button>
              <Button size="sm" onClick={() => nav("/register")} data-testid="nav-signup-btn" className="bg-slate-900 hover:bg-slate-800">
                Get started — free
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
